/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finals_Require_RoundsInputs */



/**
* | output |
* | --- |
* | "Finals require at least 2 rounds and 5 players with results." |
*
* @param {Finals_Require_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finals_require_rounds = /** @type {((inputs?: Finals_Require_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finals_Require_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La finale nécessite au moins 2 rondes et 5 joueurs avec des résultats.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las finales requieren al menos 2 rondas y 5 jugadores con resultados.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finais requerem pelo menos 2 rodadas e 5 jogadores com resultados.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le finali richiedono almeno 2 round e 5 giocatori con risultati.")
	return /** @type {LocalizedString} */ ("Finals require at least 2 rounds and 5 players with results.")
});